<template>

<div @click="appClick" v-bind:style="christmasClass">

  <!--Audio-->
  <audio ref="audio" v-if="audioUrl" autoplay loop muted>
      <source :src="audioUrl">
      Your browser does not support the audio tag.
  </audio>

<!--loading conmonent on appllo request-->
<div class="loadingClass">
  <Loading v-if="$apollo.loading"></Loading>  
</div>

<div class="mainClass">

  <!--Animation-->
  <Animation></Animation>

  <v-row>

    <v-col
      cols="4"
      offset="4"
      class="titleClass"
      >
        <div v-if="rolesExists" >
            <span class="text3D">App List</span>
        </div>
        <div v-else  class="text-h4">😢 user not found. If you are not registered in Nikita follow the link below.</div>
    </v-col>

    <v-col
      cols="12"
      sm="4"
      md="2"
      lg="2"
      xl="2"
      class="ml-auto" 
    >   

      <CustomForm
      v-if="rolesExists"
      :filterArrayProps="searchCellForm"
      :autoSubmit="true"
      @submitEvent="goToChart"
      ></CustomForm>

    </v-col>
  </v-row>

  <v-row
  justify="center"
  v-if="!search && rolesExists"
  >
    <v-col
    cols="12"
    sm="12"
    md="12"
    lg="12"
    xl="12"
    >

      <v-tabs
        v-model="selectedTab"
        :centered="true"
        center-active
        show-arrows
        background-color="transparent"
      >
        <v-tab v-for="group in groupList" class="tabClass"
        :key="group">
          <v-btn rounded :color="group == groupList[selectedTab] ?  'green' : 'default' ">{{group}}</v-btn>
        </v-tab>

        <v-tabs-slider color="transparent"></v-tabs-slider>
      
      </v-tabs>
    
    </v-col>
</v-row>


  <v-row
  justify="center"
  >

    <v-col
    cols="8"
    >

      <div>
        <v-row
        :justify="rolesExists ? null : 'center'"
        >
            <v-col v-for="(item, i) in items"
                  :key="i"
                  cols="12"
                  sm="12"
                  md="6"
                  lg="6"
                  xl="4"
                >
                  <custom-card
                  class="card-highlight"
                  :title="item.title"
                  :description="item.description"
                  :imageurl="item.imageurl"
                  :id="item.id"
                  :accessCounter="item.accesscounter"
                  :lastAccess="item.lastaccessstr"
                  :creationDate="item.creationdatestr"
                  :avgdayusage="item.avgdayusage"
                  >
                  </custom-card>
                  
                </v-col>
        </v-row>
      </div>

    </v-col>

  </v-row>

</div>

</div>
  
</template>

<script>

import CustomCard from "@/components/card/CustomCard.vue"

import Loading from "@/components/loading/Loading.vue"

import CustomForm from "@/components/form/CustomForm.vue"

//Animation
import Animation from "@/components/animation/Animation.vue"

//Query
import {
  QueryGetItemListGroup,
  QueryGetItemListByTitle,
  QueryGetGroupList,
  QueryAutocompleteCellname,
  QueryGetUiLinkByName,
  increaseAccessCountById,
  QueryGetTodayHoliday
} from "@/constants/graphql.js"

//css
import "./Portal.css"

export default {

    components: {
      CustomCard,
      Loading,
      CustomForm,
      Animation
    },

    inject: ["getSearch"], //Get provided variable from MainLyout.vue 

    data: () => {
        return({
            items:[],
            search: "",
            groupList: null,
            selectedTab: null,
            searchCellForm: [
              {id: "1", name: 'cellname', label:"cellname", type:'autocomplete', validation:true, searchLength:1, errorMessage: 'Cellname is required', graphqlquery: QueryAutocompleteCellname, graphqlqueryString: "getAutocompleteCellname", xs:12, sm:12, md:12, lg:12},
            ],
            chartApp: null,
            rolesExists: localStorage.getItem("roles") != null && JSON.parse(atob(localStorage.getItem("roles"))).length != 0 ? true : false,
            christmasClass: null,
            audioUrl: null
        })
    },

    computed:{
      //Computed variable that change with injected variable 
      injectedSearch(){
          return this.getSearch();
      }
    },

    watch:{
      search(val){
        if(!val){ //Is search is empty, reload previous group
          this.$apollo.queries.items.refetch();
        }
      },

      //Every time injected search change refetch query
      injectedSearch(val){
        this.search = val
      }
    },

    //methods
    methods:{
      goToChart(event){

        //Increase access count
        this.$apollo.mutate({
                mutation: increaseAccessCountById,
                variables:{
                    id: this.chartApp.id 
                }
            }).then((data) => {
                //Only if success open window
                window.open(data.data.increaseAccessCount.url + "?ucella=" + event.cellname, "_blank")
            }).catch((error) => {
                console.log(error)
            });
      },

      playSound(){
        if(this.audioUrl !== null){
            this.$refs.audio.play();
        }
      },

      //When user click everywhere on screen start sound
      appClick(){
        this.playSound();
      }

    },

    //Apollo query
    apollo: {

      items: {
        query: QueryGetItemListGroup,
        variables(){
          return{
            groupname: this.groupList[this.selectedTab]
          }
        },
        update: (data) => {
          return data.getUiLinkListGroup
        },
        skip(){
          return this.selectedTab != null ? false : true
        }
      },

      //Search app by name
      itemsName:{
        query: QueryGetItemListByTitle,
        update: function(data) {
          this.items = data.getUiLinkListByTitle
        },
        //Every time search change query will be refetched
        variables () {
          return {
            title: this.search
          }
        },
        // Disable the query
        skip () {
          return !this.search ? true : false
        },
      },

      //Get all groups
      groupList: {
        query: QueryGetGroupList,
        update: function(data){
          this.selectedTab = data.getGroupList ? 0 : null
          return data.getGroupList
        }
      },

      //Get perf chart url
      chartApp: {
        query: QueryGetUiLinkByName,
         variables () {
          return {
            name: "nikita_chart"
          }
        },
        update: function(data){
          return data.getUiLinkByName
        }
      },

      //Holidays animations
      //Get background image and audio
      backgroundAndAudio: {
            query: QueryGetTodayHoliday,
            update: function(data) {

                if(data.getTodayHoliday !== null){
                    //Background
                    this.christmasClass = {
                        backgroundImage: "url(" + data.getTodayHoliday.background + ")",
                        backgroundSize: "cover"
                    }

                    //Audio
                    this.audioUrl = data.getTodayHoliday.audio;
                }
            }
      }
    }

}
</script>

<style scoped>

.tabClass{
  color: transparent !important;
}

.text3D {
    /*position: absolute;*/
    /*top: 50%;*/ 
    /*right: 50%;*/
    transform: translate(50%,-50%);
    text-transform: uppercase;
    font-family: verdana;
    font-size: 2.5em;
    font-weight: 700;
    color: #f5f5f5;
    text-shadow: 1px 1px 1px #919191,
        1px 2px 1px #919191,
        1px 3px 1px #919191,
        1px 4px 1px #919191,
        1px 5px 1px #919191,
        1px 6px 1px #919191,
        1px 7px 1px #919191,
        1px 8px 1px #919191,
        1px 9px 1px #919191,
        1px 10px 1px #919191,
    1px 18px 6px rgba(15, 199, 231, 0.4),
    1px 22px 10px rgba(15, 199, 231, 0.4), /*rgba(16,16,16,0.2),*/
    1px 25px 35px rgba(15, 199, 231, 0.4), /*rgba(16,16,16,0.2),*/
    1px 30px 60px rgba(15, 199, 231, 0.4); /*rgba(16,16,16,0.2),*/
}


</style>